var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "matrix-table" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.dataList,
            "default-sort": _vm.sortObj,
            "header-cell-style": _vm.headerStyle,
            "max-height": _vm.heightStr,
          },
          on: {
            "sort-change": _vm.sortTableFun,
            "selection-change": _vm.onSelectionChange,
          },
        },
        [
          _vm._l(
            _vm.config,
            function (
              {
                type,
                prop,
                label,
                width,
                slot,
                align,
                fixed,
                sortable,
                fixWidth,
                children,
                prophtml,
              },
              index
            ) {
              return [
                type
                  ? _c("el-table-column", {
                      key: index,
                      attrs: {
                        label: label,
                        type: type,
                        width: width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        width: fixWidth,
                        fixed: fixed,
                        align: align,
                        sortable: sortable,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "image"
                                  ? _c("el-image", {
                                      attrs: {
                                        src: scope.row.imageArr[0],
                                        "preview-src-list": scope.row.imageArr,
                                      },
                                    })
                                  : _vm._e(),
                                slot === "firstImage"
                                  ? _c("el-image", {
                                      attrs: {
                                        src: scope.row.firstImageArr[0],
                                        "preview-src-list":
                                          scope.row.firstImageArr,
                                      },
                                    })
                                  : _vm._e(),
                                slot === "detailImage"
                                  ? _c("el-image", {
                                      attrs: {
                                        src: scope.row.detailImageArr[0],
                                        "preview-src-list":
                                          scope.row.detailImageArr,
                                      },
                                    })
                                  : _vm._e(),
                                slot === "images"
                                  ? _c("el-image", {
                                      attrs: {
                                        src: _vm.imageArr[scope.$index],
                                        "preview-src-list": _vm.imageArr,
                                      },
                                    })
                                  : _vm._e(),
                                slot === "imageMain"
                                  ? _c("el-image", {
                                      attrs: { src: scope.row.mainImage },
                                    })
                                  : _vm._e(),
                                slot === "mainImage"
                                  ? _c("el-image", {
                                      attrs: { src: scope.row.image },
                                    })
                                  : _vm._e(),
                                slot === "index"
                                  ? _c("el-input", {
                                      attrs: { placeholder: "请输入内容" },
                                      model: {
                                        value: scope.$index,
                                        callback: function ($$v) {
                                          _vm.$set(scope, "$index", $$v)
                                        },
                                        expression: "scope.$index",
                                      },
                                    })
                                  : _vm._e(),
                                slot === "input"
                                  ? _c("el-input", {
                                      attrs: { placeholder: "请输入内容" },
                                      model: {
                                        value: scope.row.goodsNo,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "goodsNo", $$v)
                                        },
                                        expression: "scope.row.goodsNo",
                                      },
                                    })
                                  : _vm._e(),
                                slot === "money"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.moneyFormat)),
                                    ])
                                  : _vm._e(),
                                slot === "button"
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOperateEmit(
                                              "receiveData",
                                              scope.row,
                                              "details"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("查看详情")]
                                    )
                                  : _vm._e(),
                                slot === "button"
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOperateEmit(
                                              "receiveData",
                                              scope.row,
                                              "edit"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                                slot === "operation"
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOperateEmit(
                                              "receiveData",
                                              scope.row,
                                              "edit"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                                slot === "details"
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOperateEmit(
                                              "receiveData",
                                              scope.row,
                                              "details"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("查看详情")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "operation" },
                                  [
                                    slot === "money" &&
                                    scope.row.applyStatus === 2 &&
                                    _vm.parArray.indexOf(
                                      "commissionApply_payment"
                                    ) > -1
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.withdraw(
                                                  "withdraw",
                                                  scope.row,
                                                  "withdraw"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("打款")]
                                        )
                                      : _vm._e(),
                                    slot === "money" &&
                                    scope.row.applyStatus === 1
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.withdrawPass(
                                                  "withdrawPass",
                                                  scope.row,
                                                  "withdrawPass"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("通过")]
                                        )
                                      : _vm._e(),
                                    slot === "money" &&
                                    scope.row.applyStatus === 1
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.withdrawNoPass(
                                                  "withdrawNoPass",
                                                  scope.row,
                                                  "withdrawNoPass"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("不通过")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                slot === "giftName"
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "line-clamp",
                                        attrs: { title: scope.row.name },
                                      },
                                      [_vm._v(_vm._s(scope.row.name))]
                                    )
                                  : _vm._e(),
                                slot === "html"
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          scope.row.goodsNo +
                                            "<br>" +
                                            scope.row.categoryName
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                slot === "payPlaceOrderNum"
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(scope.row.payPlaceOrderNum)
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "approveOrderNum"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.approveOrderNum)),
                                    ])
                                  : _vm._e(),
                                slot === "goodsNames"
                                  ? _c("div", [
                                      scope.row.goodsNames
                                        ? _c(
                                            "ul",
                                            { staticClass: "goods-names" },
                                            _vm._l(
                                              scope.row.goodsNames,
                                              function (item, index) {
                                                return _c(
                                                  "li",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item ? item : "-")
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _c("p", [_vm._v("-")]),
                                    ])
                                  : _vm._e(),
                                slot === "platformName"
                                  ? _c("div", [
                                      _c(
                                        "ul",
                                        { staticClass: "goods-names" },
                                        _vm._l(
                                          scope.row.platformName,
                                          function (item, index) {
                                            return _c("li", { key: index }, [
                                              _vm._v(_vm._s(item)),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "categoryNames"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.categoryNames)),
                                    ])
                                  : _vm._e(),
                                slot === "proportion"
                                  ? _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.firstCommissionProportion
                                          ) +
                                          "%、" +
                                          _vm._s(
                                            scope.row.secondCommissionProportion
                                          ) +
                                          "%、" +
                                          _vm._s(
                                            scope.row.thirdCommissionProportion
                                          ) +
                                          "% "
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "validityTime"
                                  ? _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.validityStartTime)
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.validityEndTime) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "customer"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.customerName)),
                                    ])
                                  : _vm._e(),
                                slot === "customer"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.customerPhone)),
                                    ])
                                  : _vm._e(),
                                slot === "approvedName"
                                  ? _c("p", [
                                      _vm._v(
                                        "审核人：" +
                                          _vm._s(
                                            scope.row.approvedName
                                              ? scope.row.approvedName
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "approvedName"
                                  ? _c("p", [
                                      _vm._v(
                                        "审核时间：" +
                                          _vm._s(
                                            scope.row.approvedTime
                                              ? scope.row.approvedTime
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "paymentName"
                                  ? _c("p", [
                                      _vm._v(
                                        "打款人：" +
                                          _vm._s(
                                            scope.row.paymentName
                                              ? scope.row.paymentName
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "paymentName"
                                  ? _c("p", [
                                      _vm._v(
                                        "打款时间：" +
                                          _vm._s(
                                            scope.row.paymentTime
                                              ? scope.row.paymentTime
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "isStatus"
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.status == 1 ? "是" : "否"
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "accountNo"
                                  ? _c("div", [
                                      _c("p", [
                                        _vm._v(
                                          "账号：" +
                                            _vm._s(
                                              scope.row.accountNo
                                                ? scope.row.accountNo
                                                : "-"
                                            )
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "开户行：" +
                                            _vm._s(
                                              scope.row.bankName
                                                ? scope.row.bankName
                                                : "-"
                                            )
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "姓名：" +
                                            _vm._s(
                                              scope.row.name
                                                ? scope.row.name
                                                : "-"
                                            )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                slot === "customerMessage"
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.customerName
                                            ? scope.row.customerName
                                            : "-"
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "customerMessage"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.customerPhone)),
                                    ])
                                  : _vm._e(),
                                slot === "masterName"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.masterName)),
                                    ])
                                  : _vm._e(),
                                slot === "masterName"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.masterPhone)),
                                    ])
                                  : _vm._e(),
                                slot === "receivableAmount"
                                  ? _c("p", [
                                      _vm._v(
                                        "总价：￥" +
                                          _vm._s(
                                            scope.row.receivableAmount
                                              ? scope.row.receivableAmount
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "receivableAmount"
                                  ? _c("p", [
                                      _vm._v(
                                        "已收：￥" +
                                          _vm._s(
                                            scope.row.receivedAmount
                                              ? scope.row.receivedAmount
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "receivableAmount"
                                  ? _c("p", [
                                      _vm._v(
                                        "未收：￥" +
                                          _vm._s(
                                            scope.row.collectionAmount
                                              ? scope.row.collectionAmount
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "commissionAmount"
                                  ? _c("p", [
                                      _vm._v(
                                        "￥" +
                                          _vm._s(
                                            scope.row.commissionAmount
                                              ? scope.row.commissionAmount
                                              : "-"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "orderTime"
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.orderTime
                                            ? scope.row.orderTime
                                            : "-"
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "customerName"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.customerName)),
                                    ])
                                  : _vm._e(),
                                slot === "customerName"
                                  ? _c("p", [
                                      _vm._v(_vm._s(scope.row.customerPhone)),
                                    ])
                                  : _vm._e(),
                                slot === "platformName"
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        scope.row.platformList,
                                        function (item, index) {
                                          return _c("p", { key: index }, [
                                            _vm._v(_vm._s(item.platformName)),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : children
                  ? _c(
                      "el-table-column",
                      {
                        key: prop,
                        attrs: {
                          prop: prop,
                          label: label,
                          "min-width": width,
                          width: fixWidth,
                          align: align,
                          sortable: sortable,
                        },
                      },
                      _vm._l(children, function (itemchildren, indexchildren) {
                        return _c("el-table-column", {
                          key: indexchildren,
                          attrs: {
                            prop: itemchildren.prop,
                            "min-width": itemchildren.width,
                            width: itemchildren.fixWidth,
                            label: itemchildren.label,
                            "show-overflow-tooltip": "",
                            align: itemchildren.align,
                            sortable: itemchildren.sortable,
                          },
                        })
                      }),
                      1
                    )
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        width: fixWidth,
                        align: align,
                        sortable: sortable,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }